import { render } from "./DevelopmentWarning.vue?vue&type=template&id=23eab5bf&scoped=true"
import script from "./DevelopmentWarning.vue?vue&type=script&lang=js"
export * from "./DevelopmentWarning.vue?vue&type=script&lang=js"

import "./DevelopmentWarning.vue?vue&type=style&index=0&id=23eab5bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23eab5bf"]])

export default __exports__